/**
 * Credit Calculator
 *
 * Converts microdollars (internal cost unit) to credits (user-facing billing unit).
 *
 * Units:
 * - 1 microdollar = $0.000001 (1/1,000,000 of a dollar)
 * - 1 credit = $0.01 (1 cent)
 * - 1 credit = 10,000 microdollars
 */

const MICRODOLLARS_PER_CREDIT = 10_000;

export function microdollarsToCredits(microdollars: number): number {
  return Math.round((microdollars / MICRODOLLARS_PER_CREDIT) * 100) / 100;
}

export function creditsToMicrodollars(credits: number): number {
  return credits * MICRODOLLARS_PER_CREDIT;
}

export function calculateCreditsWithMargin(microdollars: number, margin: number = 1.0): number {
  return microdollarsToCredits(microdollars * margin);
}

export function formatCredits(credits: number): string {
  return credits.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatCreditsAsDollars(credits: number): string {
  return `$${formatCredits(credits)}`;
}
